import React from 'react';
import { cn } from '@/lib/utils';
import {
	desktopPickerPopoverShellClassName,
	desktopPickerPopoverWidthClassName
} from './desktopParameterPickerStyles';

type DesktopParameterPopoverShellProps = {
	children: React.ReactNode;
	width: keyof typeof desktopPickerPopoverWidthClassName;
	className?: string;
};

export const DesktopParameterPopoverShell = ({
	children,
	width,
	className
}: DesktopParameterPopoverShellProps) => (
	<div
		className={cn(
			desktopPickerPopoverShellClassName,
			desktopPickerPopoverWidthClassName[width],
			className
		)}
	>
		{children}
	</div>
);
